/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
/* eslint-disable react/jsx-props-no-spreading */
import useConnectionContext from '@hooks/useConnectionContext';
import {
  Form, DatePicker, Tag,
} from 'antd';
// import { Select } from '@mui/material';
import { useState } from 'react';
import request from '@api';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import classes from './index.module.css';
import ContentPanel from '../components/ContentPanel';
import Buttons from '../components/Buttons';
import { TITLE, DESC } from './const';

const { RangePicker } = DatePicker;
export default function DaysOff() {
  const form = Form.useFormInstance();
  const [selectedRanges, setSelectedRanges] = useState([]);
  const { merchantId, store = {} } = useConnectionContext();
  const { timeZone, time } = form.getFieldsValue(true);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleRangeChange = (dates) => {
    if (dates && dates.length === 2) {
      const newRange = {
        start: dates[0].format('MMM DD'),
        end: dates[1].format('MMM DD'),
        startDay: dates[0].format('YYYY-MM-DD'),
        endDay: dates[1].format('YYYY-MM-DD'),
      };
      const index = selectedRanges.findIndex((range) => range.start === newRange.start && range.end === newRange.end);
      if (index === -1) {
        setSelectedRanges([...selectedRanges, newRange]);
      }
      form.setFieldValue('daysOff', []);
    }
  };

  const handleClose = (range) => {
    const newSelectedRanges = selectedRanges.filter((item) => item.start !== range.start && item.end !== range.end);
    setSelectedRanges(newSelectedRanges);
    form.setFieldValue('daysOff', []);
  };

  const handleContinue = async () => {
    setLoading(true);
    try {
      const body = {
        merchantId,
        adminDomain: store.info,
        status: 'active',
        quoteConfig: {
          orderCutOffDailyTime: dayjs(time).format('HH:mm'),
          orderCutOffTimeZone: timeZone,
          orderCutOffDayList: selectedRanges.map((range) => ({ startDay: range.startDay, endDay: range.endDay })),
        },
      };
      const { code, message } = await request('update-merchant-gdd-configs', {
        method: 'POST',
        body,
      });

      if (code === 0) {
        console.log('submit success');
        navigate('../feedback');
      } else {
        navigate('../error', { state: { message } });
      }
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  };

  return (
    <ContentPanel title={TITLE.second} desc={DESC.second} step={2} total={2}>
      <Form.Item
        label="Days off"
      >
        <Form.Item noStyle name="daysOff">
          <RangePicker
            onChange={handleRangeChange}
            allowClear
            placeholder={['Select', '']}
            format="MMM DD"
            style={{ width: '100%' }}
          />
        </Form.Item>

        <div className={classes.tag}>
          {selectedRanges.map((range, index) => (
            <Tag
              // eslint-disable-next-line react/no-array-index-key
              key={Date.now() + index}
              closable
              onClose={() => handleClose(range)}
            >
              {range.start}
              {' '}
              -
              {range.end}
            </Tag>
          ))}
        </div>
      </Form.Item>

      <Buttons
        backUrl="../processing-time"
        isDisabled={!selectedRanges.length}
        onSubmit={handleContinue}
        nextText="Submit →"
        loading={loading}
      />

    </ContentPanel>

  );
}
